import render from '@tk/utilities/tk.render';

const showProgressBar = (elementToAttach?: HTMLElement) => {
    const progressBar = render(`
        <div class="tk-progress tk-progress--infinite tk-progress--sticky tk-progress--breakout">
            <div class="tk-progress__bar"></div>
        </div>
    `);
    if (elementToAttach) {
        elementToAttach.insertAdjacentElement('afterbegin', progressBar);
        return progressBar;
    } else {
        const dialog = Array.from(document.querySelectorAll('dialog[open]'));
        dialog.length > 0
            ? dialog.at(-1)?.insertAdjacentElement('beforeend', progressBar)
            : document.body.insertAdjacentElement('beforeend', progressBar);
        return progressBar;
    }
};

export default showProgressBar;
